/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import Regimen from './regimen';
import RegimenDetail from './regimen-detail';
import RegimenUpdate from './regimen-update';
import RegimenDeleteDialog from './regimen-delete-dialog';

const RegimenRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<Regimen />} />
    <Route path="new" element={<RegimenUpdate />} />
    <Route path=":id">
      <Route index element={<RegimenDetail />} />
      <Route path="edit" element={<RegimenUpdate />} />
      <Route path="delete" element={<RegimenDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default RegimenRoutes;
